import { CampaignData } from '@/typings/interfaces/data/campaign';
import { CampaignModel } from '@/models/CampaignModel';
import { FlowpageModel } from '@/components/layout/FlowpageModel';

export interface State {
  /**
   * Demo token is that unique campaign token that is used to
   * identify calls throughout the system as coming from the demo view.
   */
  demoToken?: string;
  data?: CampaignData;
  model?: CampaignModel;
  flowId?: number;
  popoverId?: number;
  flowOverlay: boolean;
  fictiveFlowPage?: FlowpageModel;
  noMoreFlowPages: boolean;
}

export const state = (): State => {
  return {
    demoToken: undefined,
    data: undefined,
    model: undefined,
    flowId: undefined,
    popoverId: undefined,
    flowOverlay: false,
    noMoreFlowPages: false
  };
};
